( function ( _s ) {
	_s.fn.passwordInput = function () {
		return this.each( el => {
			const _self = _s( el );

			_self.addClass( 'password-input' );
			_self.wrap( '<div class="password-wrapper"></div>' );
			_self.after(
				'<span class="password-toggle" aria-label="Show/Hide password" tabindex="0"></span>'
			);

			const _passwordToggle = _self.parent().find( '.password-toggle' );

			const passwordToggle = () => {
				if ( _self.attr( 'type' ) == 'password' ) {
					_self.attr( 'type', 'text' );
				} else {
					_self.attr( 'type', 'password' );
				}
			};

			_passwordToggle.on( 'click', () => {
				passwordToggle();
			} );

			_passwordToggle.on( 'keyup', e => {
				if ( window.isEventKeyEnter( e ) ) {
					passwordToggle();
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '[type=password]' ).passwordInput();
	} );
} )( window._s );
